import { useMediaQuery } from '@mui/material'
import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react'
import DesktopDisciplineContent from 'components/Layout/Header/DisciplineContent/DesktopDisciplineContent/DesktopDisciplineContent'

import MobileDisciplineContent from 'components/Layout/Header/DisciplineContent/MobileDisciplineContent/MobileDisciplineContent'
import {
  DesktopContainer,
  MobileContainer
} from 'components/common/common.style'
import { themeUtils } from 'styles/theme'

interface DisciplineContentProps {
  isOpen: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
  allCurrencies: string[]
}

export default function DisciplineContent({
  isOpen,
  setOpen,
  allCurrencies
}: DisciplineContentProps) {
  const desktopRef = useRef<HTMLDivElement>(null)
  const [maxWidth, setMaxWidth] = useState<number | undefined>(undefined)
  const isMobile = useMediaQuery(themeUtils.maxWidth.md)

  useEffect(() => {
    function updateMaxWidth() {
      if (desktopRef.current) {
        const rect = desktopRef.current.getBoundingClientRect()
        setMaxWidth(window.innerWidth - rect.left - window.innerWidth * 0.05)
      }
    }

    updateMaxWidth()
    window.addEventListener('resize', updateMaxWidth)
    return () => window.removeEventListener('resize', updateMaxWidth)
  }, [desktopRef])
  return (
    <>
      {!isMobile ? (
        <DesktopContainer ref={desktopRef}>
          <DesktopDisciplineContent
            isOpen={isOpen}
            setOpen={setOpen}
            maxWidth={maxWidth}
          />
        </DesktopContainer>
      ) : (
        <MobileContainer>
          <MobileDisciplineContent
            isOpen={isOpen}
            setOpen={setOpen}
            allCurrencies={allCurrencies}
          />
        </MobileContainer>
      )}
    </>
  )
}
